const SUS = (state = [], action) => {

	let SUS;

	switch (action.type) {

		case 'PUT_SUS':

			SUS = action.payload.sus;

			// Put routes into array for ordering, turn back into object.
			let SUSarray = [];

			Object.keys(SUS).forEach(key => {

				if (SUS[key] !== true) {
					SUSarray.push(SUS[key]);
				}
			});

			SUSarray.sort(function(a, b) {
				let nameA = (a.name ? a.name.toUpperCase() : '');
				let nameB = (b.name ? b.name.toUpperCase() : '');

				let sort = 0;

				if (nameA !== '' || nameB !== '') {
					if (nameA < nameB) {
						sort = -1;
					}

					if (nameA > nameB) {
						sort = 1;
					}
				}

				return sort;

			});

			let SUSobj = {};

			for (let i = 0; i < SUSarray.length; ++i) {
				SUSobj[i] = SUSarray[i];
			}

			SUS = SUSobj;

			return { ...SUS };

		case 'CLEAR_SUS':

			SUS = {};

			return { ...SUS };

		default:

			return state;
	}
}

export default SUS;



// WEBPACK FOOTER //
// ./src/reducers/sus.js